$(document).ready(function () {
  // Accordion functionality
  $(document).on("click", ".accord_title", function () {
    const $parent = $(this).parent();
    if ($parent.hasClass("shrink")) {
      $(".accord_wrap .accord_item").addClass("shrink");
      $(".accord_wrap .accord_item .accord_desc").slideUp();
    }
    $parent.toggleClass("shrink").find(".accord_desc").slideToggle();
  });

  // Mobile menu toggle
  $(document).on("click", ".mobile-menu-cta", function () {
    $(this).toggleClass("active");
    $(".header_menu").slideToggle();
    $(".filter_input").removeClass("active");
    $(".filter_options").fadeOut();
    return false;
  });

  // Filter dropdown toggle
  $(document).on("click", ".filter_title", function () {
    const $parent = $(this).parent();
    $(".filter_input").not($parent).removeClass("active");
    $(".filter_options").not($parent.find(".filter_options")).fadeOut();
    $parent.toggleClass("active").find(".filter_options").fadeToggle();
  });

  // Close filter dropdown when clicking outside
  $(document).on("click", function (e) {
    if (!$(e.target).closest(".filter_input").length) {
      $(".filter_input").removeClass("active");
      $(".filter_options").fadeOut();
    }
  });

  // Clear filter options
  $(document).on("click", ".filter_options_clear", function () {
    const $parent = $(this).parents(".filter_input");
    $parent.find(".filter_check input").prop("checked", false);
    $parent.find(".filter_counter").text(0);
    $(".filter_input").removeClass("active");
    $(".filter_options").fadeOut();
    return false;
  });

  // Update filter counter on checkbox change
  $(".filter_check input:checkbox").on("change", function () {
    const $parent = $(this).closest(".filter_input");
    const $counter = $parent.find(".filter_counter");
    let count = parseInt($counter.text(), 10) || 0;

    count += $(this).prop("checked") ? 1 : -1;
    $counter.text(count);
    return false;
  });

  // Clear all filters
  $(document).on("click", ".clearAllFilter", function () {
    $(".filter_check input").prop("checked", false);
    $(".filter_counter").text(0);
    $(".filter_input").removeClass("active");
    $(".filter_options").fadeOut();
    return false;
  });
});


(function () {
            const cardsContainer = document.getElementById('cardsList');
            const carouselInner = document.getElementById('carouselInner');
            const indicatorsContainer = document.getElementById('carouselIndicators');

            // read original cards (clone to avoid moving originals)
            const originalCards = Array.from(cardsContainer.querySelectorAll('.card-wrapper')).map(c => c.innerHTML);

            // decide items per slide based on current width
            function getItemsPerSlide() {
                const w = window.innerWidth;
                if (w >= 992) return 5;   // large
                if (w >= 768) return 3;   // medium
                return 2;                 // small
            }

            // debounce helper
            function debounce(fn, wait = 120) {
                let t;
                return (...args) => {
                    clearTimeout(t);
                    t = setTimeout(() => fn(...args), wait);
                };
            }

            // rebuild carousel slides & indicators
            function rebuildCarousel() {
                const perSlide = getItemsPerSlide();
                carouselInner.innerHTML = '';
                indicatorsContainer.innerHTML = '';

                // chunk originalCards into groups of perSlide
                const total = originalCards.length;
                const chunks = [];
                for (let i = 0; i < total; i += perSlide) {
                    chunks.push(originalCards.slice(i, i + perSlide));
                }

                // if last chunk has less than perSlide, optionally wrap from start to fill - OR keep shorter slide.
                // here we will keep the last smaller group as-is (keeps order predictable).

                chunks.forEach((group, idx) => {
                    const itemDiv = document.createElement('div');
                    itemDiv.className = 'carousel-item' + (idx === 0 ? ' active' : '');

                    // create .row and append columns
                    const row = document.createElement('div');
                    row.className = 'row justify-content-center';

                    group.forEach(html => {
                        const col = document.createElement('div');
                        /* Use responsive column: 
                           - col-6 for small (2 per row)
                           - col-md-4 for medium (3 per row)
                           - col-lg-2 for large (approx 5)
                           Note: col-lg-2 gives 6 columns of width 2 each (12/2=6) — since 5 doesn't divide 12 exactly, this is a practical compromise.
                        */
                        col.className = 'col-6 col-md-4 col-lg-2 carousel-card-col';
                        col.innerHTML = html;
                        row.appendChild(col);
                    });

                    itemDiv.appendChild(row);
                    carouselInner.appendChild(itemDiv);

                    // create indicator
                    const btn = document.createElement('button');
                    btn.type = 'button';
                    btn.setAttribute('data-bs-target', '#responsiveCarousel');
                    btn.setAttribute('data-bs-slide-to', String(idx));
                    btn.setAttribute('aria-label', 'Slide ' + (idx + 1));
                    if (idx === 0) {
                        btn.className = 'active';
                        btn.setAttribute('aria-current', 'true');
                    }
                    indicatorsContainer.appendChild(btn);
                });

                // If there is only one slide, hide indicators and controls optionally
                const controls = document.querySelectorAll('#responsiveCarousel .carousel-control-prev, #responsiveCarousel .carousel-control-next');
                if (chunks.length <= 1) {
                    indicatorsContainer.style.display = 'none';
                    controls.forEach(c => c.style.display = 'none');
                } else {
                    indicatorsContainer.style.display = '';
                    controls.forEach(c => c.style.display = '');
                }
            }

            // initial build
            rebuildCarousel();

            // rebuild on resize - debounce to avoid thrashing
            window.addEventListener('resize', debounce(() => {
                // preserve currently active card index? For simplicity we'll rebuild and reset to first slide.
                // If you want to preserve position, more bookkeeping is needed.
                rebuildCarousel();
            }, 130));
        })();
